import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import aboutImage from '../../assets/images/ABOUT US.jpg';
import { getImageAltText } from '../../utils/seoHelpers';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

const AboutInfo = styled.div`
  flex: 1;
  padding-right: 50px;
  
  @media (max-width: 992px) {
    padding-right: 0;
    margin-bottom: 40px;
    text-align: center;
  }
`;

const AboutTitle = styled.h2`
  font-size: 16px;
  color: #777;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

// Removed unused styled component
// const AboutDescription = styled.p`
//   margin-bottom: 30px;
//   font-size: 16px;
//   line-height: 1.8;
//   color: #555;
// `;

// Removed unused styled component
// const ConsultationButton = styled.a`
//   display: inline-flex;
//   align-items: center;
//   background: transparent;
//   color: #4169e1;
//   font-weight: bold;
//   text-transform: uppercase;
//   border: 1px solid #4169e1;
//   padding: 12px 20px;
//   border-radius: 25px;
//   transition: all 0.3s;
//   cursor: pointer;
//   
//   &:hover {
//     background-color: #4169e1;
//     color: white;
//     transform: translateY(-3px);
//   }
//   
//   svg {
//     margin-left: 10px;
//   }
// `;

const AboutImage = styled.div`
  flex: 1;
  position: relative;
  
  img {
    width: 100%;
    max-width: 500px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
  
  .tech-label {
    position: absolute;
    right: 0;
    bottom: -10px;
    background-color: #fff;
    padding: 8px 16px;
    text-align: center;
    line-height: 1.3;
    font-weight: 600;
    font-size: 14px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  @media (max-width: 992px) {
    display: flex;
    justify-content: center;
    
    .badge {
      right: 0;
    }
  }
`;

const StyledAbout = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;

const About = ({ id }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  
  // Define bilingual alt texts
  const aboutImageAltText = getImageAltText(
    t,
    'about.image.alt',
    'State-of-the-art dental technology at National Medical Elite Clinic',
    'تقنية طب الأسنان المتطورة في عيادة النخبة الوطنية الطبية',
    i18n.language
  );
  
  return (
    <StyledAbout id={id}>
      <Container>
        <AboutInfo>
          <AboutTitle>{t('home.about.title').toUpperCase()}</AboutTitle>
          {isRtl ? (
            /* Arabic layout - showing as two paragraphs as requested */
            <div style={{ direction: 'rtl', textAlign: 'right' }}>
              <p style={{
                fontSize: '20px',
                lineHeight: '1.8',
                color: '#333',
                margin: '0',
                padding: '0 0 20px 0'
              }}>
                {t('home.about.paragraph1')}
              </p>
              <p style={{
                fontSize: '16px',
                lineHeight: '1.8',
                color: '#333',
                margin: '0',
                padding: '0'
              }}>
                {t('home.about.paragraph2')}
              </p>
            </div>
          ) : (
            /* English layout - new paragraph structure */
            <div>
              <p style={{
                fontSize: '20px',
                fontWeight: '600',
                lineHeight: '1.8',
                color: '#333',
                margin: '0',
                padding: '0 0 20px 0'
              }}>
                {t('home.about.paragraph1')}
              </p>
              <p style={{
                fontSize: '16px',
                lineHeight: '1.8',
                color: '#333',
                margin: '0',
                padding: '0'
              }}>
                {t('home.about.paragraph2')}
              </p>
            </div>
          )}
          
        </AboutInfo>
        
        <AboutImage>
          <img 
            src={aboutImage}
            alt={aboutImageAltText}
            data-alt-key="about.image.alt"
            data-alt-en="State-of-the-art dental technology at National Medical Elite Clinic"
            data-alt-ar="تقنية طب الأسنان المتطورة في عيادة النخبة الوطنية الطبية"
          />
          <div className="tech-label">
            {t('home.about.techLabel.innovative')}<br />{t('home.about.techLabel.technology')}
          </div>
        </AboutImage>
      </Container>
    </StyledAbout>
  );
}

export default About;
